<!--肝脏增强MR-->
<script setup>
import { computed, reactive,ref } from "vue";
import { useCrfStore } from "@/stores/crf";
import upload from "@/components/upload1.vue"
import check from "./check.vue";
import BGWJ from "@/components/BGWJ.vue"
import uploadzip from "@/components/upload.vue";
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0

// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});

// 表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
</script>
<template>
  <template v-if="crfFields">
    <div style="display:flex;">
      <h2>肝脏增强MR</h2>
      <upload :type="props.type" :data="model" name="gzzqmr"></upload>
      <check :period="props.type" text="肝脏增强MR" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
    </div>
    <el-form-item label="肝脏增强MR检查是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['肝脏增强MR检查是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['肝脏增强MR检查是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'患者是否新增肝脏增强MR检查？':'患者是否进行肝脏增强MR检查？'" class="redStar">
          <el-radio-group v-model="crfFields['患者是否进行肝脏增强MR检查？']">
            <el-radio label="是"></el-radio>
            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="crfFields['患者是否进行肝脏增强MR检查？'] == '是'">

          <el-form-item label="侧支循环开放"  :prop="itemProp(`肝脏增强MR_侧支循环开放`)" :rules="crfStore.radioRules(`侧支循环开放`,true)"  class="redStar" >
            <el-radio-group v-model="crfFields['肝脏增强MR_侧支循环开放']">
              <el-radio label="有" prop="有"></el-radio>
              <el-radio label="无" prop="无"></el-radio>
              <el-radio label="未测" prop="未测"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="门静脉血栓" :prop="itemProp(`肝脏增强MR_门静脉血栓`)" :rules="crfStore.radioRules(`门静脉血栓`,true)" class="redStar">
            <el-radio-group v-model="crfFields['肝脏增强MR_门静脉血栓']">
              <el-radio label="有" prop="有"></el-radio>
              <el-radio label="无" prop="无"></el-radio>
              <el-radio label="未测" prop="未测"></el-radio>
            </el-radio-group>
          </el-form-item>
          <BGWJ :type="props.type" :data="model" btn_name="DICOM文件请上传百度网盘-gzzqmr"></BGWJ>

        </template>
      </template>
    <!-- <el-form-item label="肝脏增强MR" :prop="itemProp('肝脏增强MR')">
      <el-input v-model="crfFields['肝脏增强MR']" type="textarea"
                placeholder="请输入肝脏磁共振报告"></el-input>
    </el-form-item>
    <el-form-item label="肝脏病理" :prop="itemProp('肝脏病理')">
      <el-input v-model="crfFields['肝脏病理']" type="textarea"
                placeholder="请输入肝脏病理"></el-input>
    </el-form-item> -->

  </template>
</template>

<style scoped>
</style>